import { render, staticRenderFns } from "./checkout-success.vue?vue&type=template&id=56475933&"
import script from "./checkout-success.vue?vue&type=script&lang=js&"
export * from "./checkout-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports